import React, { useCallback, useContext, useEffect, useRef, useState , } from "react";
import './message.css';
import './audio-video.css';
import './PhoneCallCreate.css';
import './ZoomCreate.css';
import medicalIcon from '../../assets/images/medical-prescription.png';
import referralIcon from '../../assets/images/referral.png';
import ZoomContext from "../../ContextsAndProvider/Zoom-Context";
import { canAddToWaitingRoom, getSignature, toggleFullscreen } from "./functions";
import BookingModal from "../Admin/Scheduling/booking/BookingModal";
import AddToWaitingRoomModal from "../Admin/Dashboard/AddToWaitingRoomModal";
import ZoomVideoPlayer from "./ZoomVideoPlayer";
import { failed, info, success } from "../common/Toastify";
import { Menu, MenuItem, MenuList, ClickAwayListener, ListItemIcon } from "@mui/material";
import { KeyboardArrowDown, CallEndOutlined, Fullscreen, FullscreenExit, MicOffOutlined, MicOutlined, VideocamOffOutlined, VideocamOutlined, Check, CallOutlined, Refresh } from "@mui/icons-material";
import { InviteInSeesion } from "./InviteInSession";
import { notifyAppointmentSessionReady } from "../api/Scheduling/notifications";
import { Button } from "../common/Button";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { FullPageSpinner } from "../common/Spinner/FullPageSpinner";
import { decryptData } from "../EncryptDecrypt";
import { useBeforeUnload } from "react-use";
import { endWaitingRoomMeeting, editQueueItem} from "../apps/api/WaitingRoom";
import { getEncounterRecord, getActivePractitioners, getQueueRecord, editEncounter } from "../apps/api/Encounter";
import { ZoomChatBox } from "./ZoomChatBox";
import QuestionnaireBox from "./QuestionnaireBox";
import { AUTH_TOKEN_REFRESHED_EVENT } from "../../lib/axios";
import { useGetOrgLicensedProducts } from "../../hooks/ReactQueryHooks/useGetOrgLicensedProducts";
import { getOrganization } from "../api/Organization";
import { getPatientData, getSingleUser } from "../api/Individual";
import moment from "moment";
import EncounterDetail from "../apps/Patient/EncounterDetail";
import ConfirmationModal from "../common/ConfirmationModal";
import { createProtocolResponse, getProtocolResponsesByEncounterId } from "../apps/api/Protocol";
import TriageParentComponent from "../apps/Protocol/TriageParentComponent";
import { capitalizeWords } from "../../utils/capitalizeWords";
import { safeAgeString, ViewDate } from "../../utils/DateSupport";
import { Resources } from "./Resources";
import { syncMissingParticipantsFromStatusHistory } from '../../utils/EncounterSupport';
import { deviceWebSocketEndpoint } from "../../environment";
import { useDeviceWebSocket } from "../../features/deviceWebSocket/useDeviceWebSocket";
import { DEVICE_WEBSOCKET_STATE } from "../../features/deviceWebSocket/deviceWebSocketClient";
import {
    CLINICAL_DEVICES_RESOURCE,
    CLINICAL_DEVICE_IDS,
    CLINICAL_DEVICE_MESSAGE_TASKS,
    CLINICAL_STREAM_STATES,
    DEFAULT_PTZ_STEP,
    DEVICE_MESSAGE_ACTION,
    DEVICE_MESSAGE_TYPES,
    DEVICE_MESSAGE_VERSION,
    MAIN_CAMERA_RESOURCE,
    PTZ_MESSAGE_TASKS,
    PTZ_RESULT_STATUSES,
    createDeviceMessageId,
} from "../../features/deviceWebSocket/deviceMessageProtocol";
import { useClinicalDeviceViewer } from "../../features/clinicalWebRtc/useClinicalDeviceViewer";
import { getAccessToken } from "../../utils/authStorage";
import KioskPtzControls from "./KioskPtzControls";
import KioskClinicalDeviceStatus, {
    KIOSK_CLINICAL_DEVICE_STATUS_STATE,
} from "./KioskClinicalDeviceStatus";
import ClinicalDeviceStreamView from "./ClinicalDeviceStreamView";
import EndCallConfirmationModal from "./EndCallConfirmationModal";

const PTZ_ACK_RETRY_BASE_MS = 3_000;
const PTZ_ACK_RETRY_MAX_MS = 12_000;
// Device changes are pushed immediately. This round trip detects a kiosk that
// disappears without a clean WebSocket close and also prevents relay idling.
const KIOSK_STATUS_HEARTBEAT_MS = 15_000;
const KIOSK_STATUS_RESPONSE_TIMEOUT_MS = 5_000;
const KIOSK_STATUS_RETRY_BASE_MS = 5_000;
const KIOSK_STATUS_RETRY_MAX_MS = 30_000;
const CLINICAL_DEVICE_LABELS = Object.freeze({
    [CLINICAL_DEVICE_IDS.STETHOSCOPE]: "Stethoscope",
    [CLINICAL_DEVICE_IDS.EAR_CAMERA]: "Ear camera",
    [CLINICAL_DEVICE_IDS.EXAM_CAMERA]: "Exam camera",
});
const CLINICAL_STREAM_COMMAND_RETRY_BASE_MS = 2_000;
const CLINICAL_STREAM_COMMAND_RETRY_MAX_MS = 15_000;
const CLINICAL_STREAM_RESYNC_MS = 15_000;
const ZOOM_SESSION_HEALTH_CHECK_MS = 5_000;

const getParticipantInitials = (displayName = "") => displayName
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((name) => name.charAt(0).toUpperCase())
    .join("") || "?";

const stopZoomMedia = (stream) => {
    if (!stream) return Promise.resolve([]);

    return Promise.allSettled([
        Promise.resolve().then(() => (
            stream.isCapturingVideo?.() ? stream.stopVideo() : undefined
        )),
        Promise.resolve().then(() => stream.stopAudio?.()),
    ]);
};


function ZoomCreate() {
    const navigate = useNavigate()
    const { state: routeState } = useLocation();
    const state = routeState || {};
    const isInMeetingRef = useRef(false);
    useBeforeUnload(() => isInMeetingRef.current, 'You are in an ongoing meeting. Leaving will end your meeting.');
    const { topic, sessionToken, password, intakeQuestions, encounterId} = state
    const [modalShow, setModalShow] = useState(false);
    const [patientName, setPatientName] = useState("");
    const [resourceModalShow, setResourceModalShow] = useState(false)
    const [encounterDetailsShow, setEncouterDetailsShow]= useState(false);
    const [mediaStream, setMediaStream] = useState(null);
    const mediaStreamRef = useRef(null);
    const [chatClient, setChatClient] = useState(null);
    const [currentUser, setCurrentUser] = useState({});
    const [participants, setParticipants] = useState([]);
    const [isCameraLoading, setIsCameraLoading] = useState(false);
    const [isAudioLoading, setIsAudioLoading] = useState(false);
    const [isSessionJoined, setIsSessionJoined] = useState(false);
    const [hasJoinedZoomSession, setHasJoinedZoomSession] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [loadingText, setLoadingText] = useState('');
    const [sessionChat, setSessionChat] = useState([]);
    const [showChat, setShowChat] = useState(false);
    const [isCameraOn, setIsCameraOn] = useState(false);
    const [isMicOn, setIsMicOn] = useState(false);
    const chatInput = useRef();
    const [isAudioStreaming, setIsAudioStreaming] = useState(false);
    const [encounterFinished, setEncounterFinished] = useState(false);
    const [hasEndedZoomSession, setHasEndedZoomSession] = useState(false);
    const [orgnization, setOrganizations] = useState({})
    const [isFull, setIsFull] = useState(false);
    const adminOrgs = useSelector((state) => state?.auth?.user?.organizations)
    const zmClient = useContext(ZoomContext);
    const zoomEventHandlersRef = useRef([]);
    const zoomConnectionChangeHandlerRef = useRef(() => undefined);
    const zoomSessionHealthCheckRef = useRef(() => undefined);
    const zoomInitializedRef = useRef(false);
    const zoomSessionTokenRef = useRef(sessionToken);
    const sessionJoinedRef = useRef(false);
    const isJoiningRef = useRef(false);
    const peerVideoStateRef = useRef(new Map());
    const [mediaRevision, setMediaRevision] = useState(0);
    const [videoAspectRatios, setVideoAspectRatios] = useState({});
    const [connectionState, setConnectionState] = useState("Disconnected");
    const user = useSelector((state) => state?.auth?.user);
    const practitionerName = useSelector( (state) => state?.auth?.user?.name[0]?.text);
    const practitionerId =  useSelector((state) => state?.auth?.user?.["custom:practitioner_id"]) 
    const userRoles = useSelector((state) => state?.auth?.user?.["cognito:groups"]);
    const permissions = useSelector((state) => state?.auth?.user?.permissions) || [];
    const admin = userRoles?.includes('Super-Admin');
    const hasResourcesReadPermissions = admin || permissions.some(permission => permission === 'Access Resource Hub')
    const { data: orgLicensedProducts } = useGetOrgLicensedProducts({})
    const isVirtualCare = admin ? false : orgLicensedProducts?.virtualCare
    const isContactCenterActive = orgLicensedProducts?.callCenter;
    const [practionerData, setPractionerData] = useState({})
    const [encounterRecord, setEncounterRecord] = useState({});
    useEffect(() => {
        if (isSessionJoined) notifyAppointmentSessionReady(encounterRecord).catch(() => info("The session is connected, but the patient notification could not be queued."));
    }, [isSessionJoined, encounterRecord?.id, encounterRecord?.appointmentId, encounterRecord?.orgId]); // eslint-disable-line react-hooks/exhaustive-deps
    const [previousAssignedPractitioner, setPreviousAssignedPractitioner] = useState(null);
    const [previousParticipants, setPreviousParticipants] = useState([]);
    const [previousPractitioner, setPreviousPractitioner] = useState(null);
    const [queueRecord, setQueueRecord] = useState({});

    const [intakeQuestionnaireId, setIntakeQuestionnaireId] = useState("");
    const [patientId, setPatientId] = useState({});
    const [bookingModalShow, setBookingModalShow] = useState(false);
    const [addToWRModalShow, setAddToWRModalShow] = useState(false);

    // multi-camera and mic logic
    const [availableCameras, setAvailableCameras] = useState(null)
    const [cameraCount, setCameraCount] = useState(0);
    const [camAnchor, setCamAnchor] = useState(null);
    const camOpen = Boolean(camAnchor);
    const [selectedCamera, setSelectedCamera] = useState(null);
    const selectedCameraRef = useRef(null);
    
    const [availableMicrophones, setAvailableMicrophones] = useState(null)
    const [micCount, setMicCount] = useState(0);
    const [micAnchor, setMicAnchor] = useState(null);
    const micOpen = Boolean(micAnchor);
    const [selectedMicrophone, setSelectedMicrophone] = useState(null);
    const selectedMicrophoneRef = useRef(null);
    const [isQuestionnaireCompleted, setIsQuestionnaireCompleted] = useState(false);
    const [confirmmodalShow, setconfirmmodalShow] = useState(false);
    const [endCallConfirmationShow, setEndCallConfirmationShow] = useState(false);
    const formikRef = useRef(null);
    const [triageBtnState, setTriageBtnState] = useState(true);
    const [showTriageComponent, setShowTriageComponent] = useState(false);
    const [patientData, setPatientData] = useState(null);
    const [unReadChat, setUnReadChat] = useState(false);
    const showChatRef = useRef(showChat);
    const sendDeviceMessageRef = useRef(() => false);
    const ptzAckTimeoutRef = useRef(null);
    const ptzAckRetryAttemptRef = useRef(0);
    const pendingPtzCommandRef = useRef(null);
    const cameraStatusResponseTimeoutRef = useRef(null);
    const cameraStatusRetryTimeoutRef = useRef(null);
    const cameraStatusRetryAttemptRef = useRef(0);
    const requestKioskCameraStatusRef = useRef(() => false);
    const clinicalDeviceStatusResponseTimeoutRef = useRef(null);
    const clinicalDeviceStatusRetryTimeoutRef = useRef(null);
    const clinicalDeviceStatusRetryAttemptRef = useRef(0);
    const requestKioskClinicalDeviceStatusRef = useRef(() => false);
    const pendingClinicalStreamCommandRef = useRef(null);
    const clinicalStreamCommandRetryRef = useRef(null);
    const clinicalStreamCommandRetryAttemptRef = useRef(0);
    const scheduleClinicalStreamCommandRetryRef = useRef(() => undefined);
    const syncClinicalStreamRef = useRef(() => false);
    const activeClinicalStreamRef = useRef(null);
    const clinicalStreamStatusCursorRef = useRef({
        sessionInstanceId: null,
        sequence: 0,
        retiredSessionInstanceIds: new Set(),
    });
    const [deviceSocketState, setDeviceSocketState] = useState(DEVICE_WEBSOCKET_STATE.IDLE);
    const [kioskCameraStatus, setKioskCameraStatus] = useState(null);
    const [kioskClinicalDeviceStatus, setKioskClinicalDeviceStatus] = useState(null);
    const [kioskClinicalDeviceStatusState, setKioskClinicalDeviceStatusState] = useState(
        KIOSK_CLINICAL_DEVICE_STATUS_STATE.CHECKING,
    );
    const [activeClinicalStream, setActiveClinicalStream] = useState(null);
    const [kioskClinicalStreamStatus, setKioskClinicalStreamStatus] = useState(null);
    const [pendingPtzCommand, setPendingPtzCommand] = useState(null);
    const [ptzFeedback, setPtzFeedback] = useState("");

    const deviceWebSocketOrgId = encounterRecord?.orgId
        || encounterRecord?.serviceProvider?.reference?.split("/")?.[1]
        || null;
    const isKioskEncounter = encounterRecord?.class === "kiosk";
    const {
        status: clinicalViewerStatus,
        remoteStream: clinicalRemoteStream,
        start: startClinicalDeviceViewer,
        stop: stopClinicalDeviceViewer,
    } = useClinicalDeviceViewer({
        kioskDeviceId: encounterRecord?.deviceID,
        organizationId: deviceWebSocketOrgId,
    });

    const clearCameraStatusTimers = useCallback(() => {
        if (cameraStatusResponseTimeoutRef.current) {
            clearTimeout(cameraStatusResponseTimeoutRef.current);
            cameraStatusResponseTimeoutRef.current = null;
        }
        if (cameraStatusRetryTimeoutRef.current) {
            clearTimeout(cameraStatusRetryTimeoutRef.current);
            cameraStatusRetryTimeoutRef.current = null;
        }
    }, []);

    const clearClinicalDeviceStatusTimers = useCallback(() => {
        if (clinicalDeviceStatusResponseTimeoutRef.current) {
            clearTimeout(clinicalDeviceStatusResponseTimeoutRef.current);
            clinicalDeviceStatusResponseTimeoutRef.current = null;
        }
        if (clinicalDeviceStatusRetryTimeoutRef.current) {
            clearTimeout(clinicalDeviceStatusRetryTimeoutRef.current);
            clinicalDeviceStatusRetryTimeoutRef.current = null;
        }
    }, []);

    const clearClinicalStreamCommandRetry = useCallback(({ clearCommand = true } = {}) => {
        if (clinicalStreamCommandRetryRef.current) {
            clearTimeout(clinicalStreamCommandRetryRef.current);
            clinicalStreamCommandRetryRef.current = null;
        }
        clinicalStreamCommandRetryAttemptRef.current = 0;
        if (clearCommand) pendingClinicalStreamCommandRef.current = null;
    }, []);

    const scheduleClinicalStreamCommandRetry = useCallback((command) => {
        if (pendingClinicalStreamCommandRef.current !== command) return;
        if (clinicalStreamCommandRetryRef.current) {
            clearTimeout(clinicalStreamCommandRetryRef.current);
        }

        const attempt = clinicalStreamCommandRetryAttemptRef.current;
        const retryCeiling = Math.min(
            CLINICAL_STREAM_COMMAND_RETRY_BASE_MS * (2 ** Math.min(attempt, 4)),
            CLINICAL_STREAM_COMMAND_RETRY_MAX_MS,
        );
        const delay = Math.max(500, Math.floor(Math.random() * retryCeiling));
        clinicalStreamCommandRetryRef.current = setTimeout(() => {
            clinicalStreamCommandRetryRef.current = null;
            if (pendingClinicalStreamCommandRef.current !== command) return;
            clinicalStreamCommandRetryAttemptRef.current += 1;
            sendDeviceMessageRef.current(command);
            scheduleClinicalStreamCommandRetryRef.current(command);
        }, delay);
    }, []);
    scheduleClinicalStreamCommandRetryRef.current = scheduleClinicalStreamCommandRetry;

    const queueClinicalStreamCommand = useCallback((command) => {
        clearClinicalStreamCommandRetry();
        pendingClinicalStreamCommandRef.current = command;
        clinicalStreamCommandRetryAttemptRef.current = 0;
        const sent = sendDeviceMessageRef.current(command);
        scheduleClinicalStreamCommandRetryRef.current(command);
        return sent;
    }, [clearClinicalStreamCommandRetry]);

    const requestClinicalStreamStart = useCallback((deviceId) => {
        if (!encounterId || !deviceWebSocketOrgId || !encounterRecord?.deviceID) return false;

        const previousStream = activeClinicalStreamRef.current;
        stopClinicalDeviceViewer();
        if (previousStream) {
            sendDeviceMessageRef.current({
                action: DEVICE_MESSAGE_ACTION,
                version: DEVICE_MESSAGE_VERSION,
                type: DEVICE_MESSAGE_TYPES.PERIPHERAL_CONTROL,
                resource: CLINICAL_DEVICES_RESOURCE,
                task: CLINICAL_DEVICE_MESSAGE_TASKS.STREAM_STOP,
                encounterId,
                organizationId: deviceWebSocketOrgId,
                requestId: createDeviceMessageId("clinical-stream-stop"),
                streamSessionId: previousStream.streamSessionId,
                deviceId: previousStream.deviceId,
            });
        }

        const streamSessionId = createDeviceMessageId("clinical-stream");
        const requestId = createDeviceMessageId("clinical-stream-start");
        const startCommand = {
            action: DEVICE_MESSAGE_ACTION,
            version: DEVICE_MESSAGE_VERSION,
            type: DEVICE_MESSAGE_TYPES.PERIPHERAL_CONTROL,
            resource: CLINICAL_DEVICES_RESOURCE,
            task: CLINICAL_DEVICE_MESSAGE_TASKS.STREAM_START,
            encounterId,
            organizationId: deviceWebSocketOrgId,
            requestId,
            streamSessionId,
            deviceId,
        };
        const nextStream = {
            streamSessionId,
            deviceId,
            requestId,
            startCommand,
            stopping: false,
        };
        activeClinicalStreamRef.current = nextStream;
        clinicalStreamStatusCursorRef.current = {
            sessionInstanceId: null,
            sequence: 0,
            retiredSessionInstanceIds: new Set(),
        };
        setActiveClinicalStream(nextStream);
        setKioskClinicalStreamStatus({
            state: CLINICAL_STREAM_STATES.STARTING,
            streamSessionId,
            deviceId,
        });
        queueClinicalStreamCommand(startCommand);
        return true;
    }, [
        deviceWebSocketOrgId,
        encounterId,
        encounterRecord?.deviceID,
        queueClinicalStreamCommand,
        stopClinicalDeviceViewer,
    ]);

    const requestClinicalStreamStop = useCallback(() => {
        const activeStream = activeClinicalStreamRef.current;
        stopClinicalDeviceViewer();
        if (!activeStream || !encounterId || !deviceWebSocketOrgId) return false;

        const stopCommand = {
            action: DEVICE_MESSAGE_ACTION,
            version: DEVICE_MESSAGE_VERSION,
            type: DEVICE_MESSAGE_TYPES.PERIPHERAL_CONTROL,
            resource: CLINICAL_DEVICES_RESOURCE,
            task: CLINICAL_DEVICE_MESSAGE_TASKS.STREAM_STOP,
            encounterId,
            organizationId: deviceWebSocketOrgId,
            requestId: createDeviceMessageId("clinical-stream-stop"),
            streamSessionId: activeStream.streamSessionId,
            deviceId: activeStream.deviceId,
        };
        const stoppingStream = { ...activeStream, stopping: true, stopCommand };
        activeClinicalStreamRef.current = stoppingStream;
        setActiveClinicalStream(stoppingStream);
        setKioskClinicalStreamStatus((currentStatus) => ({
            ...currentStatus,
            state: CLINICAL_STREAM_STATES.STOPPING,
        }));
        queueClinicalStreamCommand(stopCommand);
        return true;
    }, [
        deviceWebSocketOrgId,
        encounterId,
        queueClinicalStreamCommand,
        stopClinicalDeviceViewer,
    ]);

    const syncClinicalStream = useCallback(() => {
        const pendingCommand = pendingClinicalStreamCommandRef.current;
        if (pendingCommand) {
            sendDeviceMessageRef.current(pendingCommand);
            scheduleClinicalStreamCommandRetryRef.current(pendingCommand);
            return true;
        }

        const activeStream = activeClinicalStreamRef.current;
        if (activeStream?.startCommand && !activeStream.stopping) {
            pendingClinicalStreamCommandRef.current = activeStream.startCommand;
            clinicalStreamCommandRetryAttemptRef.current = 0;
            const sent = sendDeviceMessageRef.current(activeStream.startCommand);
            scheduleClinicalStreamCommandRetryRef.current(activeStream.startCommand);
            return sent;
        }
        return false;
    }, []);
    syncClinicalStreamRef.current = syncClinicalStream;

    useEffect(() => {
        if (
            !activeClinicalStream?.startCommand
            || activeClinicalStream.stopping
            || deviceSocketState !== DEVICE_WEBSOCKET_STATE.OPEN
        ) return undefined;

        const streamSessionId = activeClinicalStream.streamSessionId;
        const timer = setInterval(() => {
            const currentStream = activeClinicalStreamRef.current;
            if (
                currentStream?.streamSessionId === streamSessionId
                && !currentStream.stopping
                && pendingClinicalStreamCommandRef.current !== currentStream.startCommand
            ) {
                sendDeviceMessageRef.current(currentStream.startCommand);
            }
        }, CLINICAL_STREAM_RESYNC_MS);
        return () => clearInterval(timer);
    }, [activeClinicalStream, deviceSocketState]);

    const clearPendingPtzCommand = useCallback((commandId) => {
        if (commandId && pendingPtzCommandRef.current?.commandId !== commandId) return false;
        if (ptzAckTimeoutRef.current) {
            clearTimeout(ptzAckTimeoutRef.current);
            ptzAckTimeoutRef.current = null;
        }
        ptzAckRetryAttemptRef.current = 0;
        pendingPtzCommandRef.current = null;
        setPendingPtzCommand(null);
        return true;
    }, []);

    const handleDeviceWebSocketMessage = useCallback((message) => {
        if (message.type !== DEVICE_MESSAGE_TYPES.PERIPHERAL_CONTROL) return;

        if (message.resource === CLINICAL_DEVICES_RESOURCE) {
            if (message.task === CLINICAL_DEVICE_MESSAGE_TASKS.STATUS) {
                clearClinicalDeviceStatusTimers();
                clinicalDeviceStatusRetryAttemptRef.current = 0;
                setKioskClinicalDeviceStatus((currentStatus) => (
                    currentStatus?.sessionInstanceId === message.sessionInstanceId
                    && currentStatus.revision > message.revision
                        ? currentStatus
                        : message
                ));
                setKioskClinicalDeviceStatusState(KIOSK_CLINICAL_DEVICE_STATUS_STATE.CURRENT);
                return;
            }

            if (message.task !== CLINICAL_DEVICE_MESSAGE_TASKS.STREAM_STATUS) return;
            const activeStream = activeClinicalStreamRef.current;
            if (!activeStream || activeStream.streamSessionId !== message.streamSessionId) return;
            const cursor = clinicalStreamStatusCursorRef.current;
            if (message.sessionInstanceId !== cursor.sessionInstanceId) {
                if (cursor.retiredSessionInstanceIds.has(message.sessionInstanceId)) return;
                if (cursor.sessionInstanceId) {
                    cursor.retiredSessionInstanceIds.add(cursor.sessionInstanceId);
                }
                cursor.sessionInstanceId = message.sessionInstanceId;
                cursor.sequence = 0;
            }
            if (message.sequence <= cursor.sequence) return;
            cursor.sequence = message.sequence;

            setKioskClinicalStreamStatus(message);
            const pendingCommand = pendingClinicalStreamCommandRef.current;
            if (pendingCommand?.streamSessionId === message.streamSessionId) {
                const startAcknowledged = pendingCommand.task === CLINICAL_DEVICE_MESSAGE_TASKS.STREAM_START;
                const stopAcknowledged = pendingCommand.task === CLINICAL_DEVICE_MESSAGE_TASKS.STREAM_STOP
                    && message.state === CLINICAL_STREAM_STATES.STOPPED;
                if (startAcknowledged || stopAcknowledged) clearClinicalStreamCommandRetry();
            }

            if (message.state === CLINICAL_STREAM_STATES.READY && !activeStream.stopping) {
                startClinicalDeviceViewer({
                    streamSessionId: activeStream.streamSessionId,
                    deviceId: activeStream.deviceId,
                });
            } else if (message.state === CLINICAL_STREAM_STATES.FAILED) {
                stopClinicalDeviceViewer();
            } else if (message.state === CLINICAL_STREAM_STATES.STOPPED) {
                clearClinicalStreamCommandRetry();
                stopClinicalDeviceViewer();
                activeClinicalStreamRef.current = null;
                clinicalStreamStatusCursorRef.current = {
                    sessionInstanceId: null,
                    sequence: 0,
                    retiredSessionInstanceIds: new Set(),
                };
                setActiveClinicalStream(null);
            }
            return;
        }

        if (message.resource !== MAIN_CAMERA_RESOURCE) return;

        if (message.task === PTZ_MESSAGE_TASKS.STATUS) {
            clearCameraStatusTimers();
            cameraStatusRetryAttemptRef.current = 0;
            setKioskCameraStatus(message);
            if (
                pendingPtzCommandRef.current
                && pendingPtzCommandRef.current.sessionInstanceId !== message.sessionInstanceId
            ) {
                clearPendingPtzCommand();
            }
            if (!pendingPtzCommandRef.current) setPtzFeedback("");
            return;
        }

        if (message.task !== PTZ_MESSAGE_TASKS.RESULT) return;
        if (
            !pendingPtzCommandRef.current
            || pendingPtzCommandRef.current.sessionInstanceId !== message.sessionInstanceId
            || pendingPtzCommandRef.current.cameraGeneration !== message.cameraGeneration
        ) return;
        if (!clearPendingPtzCommand(message.commandId)) return;
        setPtzFeedback(
            message.status === PTZ_RESULT_STATUSES.APPLIED
                ? ""
                : message.message || "The kiosk could not move the camera.",
        );
    }, [
        clearCameraStatusTimers,
        clearClinicalDeviceStatusTimers,
        clearClinicalStreamCommandRetry,
        clearPendingPtzCommand,
        startClinicalDeviceViewer,
        stopClinicalDeviceViewer,
    ]);

    const requestKioskCameraStatus = useCallback(({ resetStatus = false } = {}) => {
        if (!encounterId || !deviceWebSocketOrgId) return false;

        clearCameraStatusTimers();
        if (resetStatus) setKioskCameraStatus(null);

        const sent = sendDeviceMessageRef.current({
            action: DEVICE_MESSAGE_ACTION,
            version: DEVICE_MESSAGE_VERSION,
            type: DEVICE_MESSAGE_TYPES.PERIPHERAL_CONTROL,
            resource: MAIN_CAMERA_RESOURCE,
            task: PTZ_MESSAGE_TASKS.STATUS_REQUEST,
            encounterId,
            organizationId: deviceWebSocketOrgId,
            requestId: createDeviceMessageId("camera-status-request"),
        });

        if (!sent) {
            setPtzFeedback("The camera-control link is reconnecting.");
            return false;
        }

        cameraStatusResponseTimeoutRef.current = setTimeout(() => {
            cameraStatusResponseTimeoutRef.current = null;
            setPtzFeedback("Retrying connection.");

            const retryAttempt = cameraStatusRetryAttemptRef.current;
            const retryDelay = Math.min(
                KIOSK_STATUS_RETRY_BASE_MS * (2 ** Math.min(retryAttempt, 6)),
                KIOSK_STATUS_RETRY_MAX_MS,
            );
            cameraStatusRetryAttemptRef.current += 1;
            cameraStatusRetryTimeoutRef.current = setTimeout(() => {
                cameraStatusRetryTimeoutRef.current = null;
                requestKioskCameraStatusRef.current();
            }, retryDelay);
        }, KIOSK_STATUS_RESPONSE_TIMEOUT_MS);

        return true;
    }, [clearCameraStatusTimers, deviceWebSocketOrgId, encounterId]);
    requestKioskCameraStatusRef.current = requestKioskCameraStatus;

    const requestKioskClinicalDeviceStatus = useCallback(({ resetStatus = false } = {}) => {
        if (!encounterId || !deviceWebSocketOrgId) return false;

        clearClinicalDeviceStatusTimers();
        if (resetStatus) {
            setKioskClinicalDeviceStatus(null);
            setKioskClinicalDeviceStatusState(KIOSK_CLINICAL_DEVICE_STATUS_STATE.CHECKING);
        }

        const sent = sendDeviceMessageRef.current({
            action: DEVICE_MESSAGE_ACTION,
            version: DEVICE_MESSAGE_VERSION,
            type: DEVICE_MESSAGE_TYPES.PERIPHERAL_CONTROL,
            resource: CLINICAL_DEVICES_RESOURCE,
            task: CLINICAL_DEVICE_MESSAGE_TASKS.STATUS_REQUEST,
            encounterId,
            organizationId: deviceWebSocketOrgId,
            requestId: createDeviceMessageId("clinical-device-status-request"),
        });

        if (!sent) {
            setKioskClinicalDeviceStatusState(KIOSK_CLINICAL_DEVICE_STATUS_STATE.UNAVAILABLE);
            clinicalDeviceStatusRetryTimeoutRef.current = setTimeout(() => {
                clinicalDeviceStatusRetryTimeoutRef.current = null;
                requestKioskClinicalDeviceStatusRef.current();
            }, KIOSK_STATUS_RETRY_BASE_MS);
            return false;
        }

        clinicalDeviceStatusResponseTimeoutRef.current = setTimeout(() => {
            clinicalDeviceStatusResponseTimeoutRef.current = null;
            setKioskClinicalDeviceStatusState(KIOSK_CLINICAL_DEVICE_STATUS_STATE.UNAVAILABLE);

            const retryAttempt = clinicalDeviceStatusRetryAttemptRef.current;
            const retryDelay = Math.min(
                KIOSK_STATUS_RETRY_BASE_MS * (2 ** Math.min(retryAttempt, 6)),
                KIOSK_STATUS_RETRY_MAX_MS,
            );
            clinicalDeviceStatusRetryAttemptRef.current += 1;
            clinicalDeviceStatusRetryTimeoutRef.current = setTimeout(() => {
                clinicalDeviceStatusRetryTimeoutRef.current = null;
                requestKioskClinicalDeviceStatusRef.current();
            }, retryDelay);
        }, KIOSK_STATUS_RESPONSE_TIMEOUT_MS);

        return true;
    }, [clearClinicalDeviceStatusTimers, deviceWebSocketOrgId, encounterId]);
    requestKioskClinicalDeviceStatusRef.current = requestKioskClinicalDeviceStatus;

    const handleDeviceSocketStateChange = useCallback((nextState) => {
        setDeviceSocketState(nextState);
        if (nextState === DEVICE_WEBSOCKET_STATE.OPEN) {
            clearCameraStatusTimers();
            cameraStatusRetryAttemptRef.current = 0;
            setPtzFeedback("");
            requestKioskCameraStatus({ resetStatus: true });
            clinicalDeviceStatusRetryAttemptRef.current = 0;
            requestKioskClinicalDeviceStatus({ resetStatus: true });
            syncClinicalStreamRef.current();
        } else {
            clearCameraStatusTimers();
            clearClinicalDeviceStatusTimers();
            clearPendingPtzCommand();
            setKioskClinicalDeviceStatus(null);
            setKioskClinicalDeviceStatusState(KIOSK_CLINICAL_DEVICE_STATUS_STATE.UNAVAILABLE);
        }
    }, [
        clearCameraStatusTimers,
        clearClinicalDeviceStatusTimers,
        clearPendingPtzCommand,
        requestKioskCameraStatus,
        requestKioskClinicalDeviceStatus,
    ]);

    const { send: sendDeviceMessage } = useDeviceWebSocket({
        enabled: isKioskEncounter,
        endpoint: deviceWebSocketEndpoint,
        getToken: getAccessToken,
        encounterId,
        organizationId: deviceWebSocketOrgId,
        scopeOfPractice: practionerData?.scopeOfPractice,
        onMessage: handleDeviceWebSocketMessage,
        onStateChange: handleDeviceSocketStateChange,
        tokenRefreshEvent: AUTH_TOKEN_REFRESHED_EVENT,
    });
    sendDeviceMessageRef.current = sendDeviceMessage;

    useEffect(() => {
        if (deviceSocketState !== DEVICE_WEBSOCKET_STATE.OPEN) return undefined;

        const heartbeatTimer = setInterval(() => {
            requestKioskCameraStatusRef.current();
            requestKioskClinicalDeviceStatusRef.current();
        }, KIOSK_STATUS_HEARTBEAT_MS);

        return () => clearInterval(heartbeatTimer);
    }, [deviceSocketState]);

    const handlePtzMovement = useCallback((movement) => {
        if (
            deviceSocketState !== DEVICE_WEBSOCKET_STATE.OPEN
            || !kioskCameraStatus?.ptzReady
            || !kioskCameraStatus.sessionInstanceId
            || !Number.isSafeInteger(kioskCameraStatus.cameraGeneration)
            || pendingPtzCommandRef.current
        ) return;

        const command = {
            action: DEVICE_MESSAGE_ACTION,
            version: DEVICE_MESSAGE_VERSION,
            type: DEVICE_MESSAGE_TYPES.PERIPHERAL_CONTROL,
            resource: MAIN_CAMERA_RESOURCE,
            task: PTZ_MESSAGE_TASKS.MOVE,
            encounterId,
            organizationId: deviceWebSocketOrgId,
            sessionInstanceId: kioskCameraStatus.sessionInstanceId,
            cameraGeneration: kioskCameraStatus.cameraGeneration,
            commandId: createDeviceMessageId("ptz-command"),
            movement,
            step: DEFAULT_PTZ_STEP,
        };

        pendingPtzCommandRef.current = command;
        ptzAckRetryAttemptRef.current = 0;
        setPendingPtzCommand(command);
        setPtzFeedback("");

        if (!sendDeviceMessageRef.current(command)) {
            clearPendingPtzCommand(command.commandId);
            setPtzFeedback("The camera-control link is unavailable.");
            return;
        }

        const scheduleAcknowledgementRetry = () => {
            const retryDelay = Math.min(
                PTZ_ACK_RETRY_BASE_MS * (2 ** Math.min(ptzAckRetryAttemptRef.current, 2)),
                PTZ_ACK_RETRY_MAX_MS,
            );

            ptzAckTimeoutRef.current = setTimeout(() => {
                ptzAckTimeoutRef.current = null;
                if (pendingPtzCommandRef.current?.commandId !== command.commandId) return;

                ptzAckRetryAttemptRef.current += 1;
                const resent = sendDeviceMessageRef.current(command);
                setPtzFeedback(
                    resent
                        ? "Still applying camera movement. Waiting for kiosk confirmation."
                        : "Camera-control link interrupted. Waiting to reconnect.",
                );

                scheduleAcknowledgementRetry();
            }, retryDelay);
        };

        scheduleAcknowledgementRetry();
    }, [
        clearPendingPtzCommand,
        deviceSocketState,
        deviceWebSocketOrgId,
        encounterId,
        kioskCameraStatus,
    ]);

    const handleClinicalDeviceAction = useCallback((deviceId) => {
        if (endCallConfirmationShow || hasEndedZoomSession) return;
        const deviceLabel = CLINICAL_DEVICE_LABELS[deviceId];
        if (!deviceLabel) return;
        const activeStream = activeClinicalStreamRef.current;
        if (activeStream?.deviceId === deviceId) {
            requestClinicalStreamStop();
            return;
        }

        const deviceAvailable = kioskClinicalDeviceStatus?.devices?.some((device) => (
            device.id === deviceId && device.available
        ));
        if (
            deviceSocketState !== DEVICE_WEBSOCKET_STATE.OPEN
            || kioskClinicalDeviceStatusState !== KIOSK_CLINICAL_DEVICE_STATUS_STATE.CURRENT
            || !deviceAvailable
        ) {
            failed(`${deviceLabel} is not currently available at the kiosk.`);
            return;
        }

        requestClinicalStreamStart(deviceId);
    }, [
        deviceSocketState,
        kioskClinicalDeviceStatus,
        kioskClinicalDeviceStatusState,
        endCallConfirmationShow,
        hasEndedZoomSession,
        requestClinicalStreamStart,
        requestClinicalStreamStop,
    ]);

    useEffect(() => () => {
        if (ptzAckTimeoutRef.current) clearTimeout(ptzAckTimeoutRef.current);
        clearCameraStatusTimers();
        clearClinicalDeviceStatusTimers();
        clearClinicalStreamCommandRetry();
        const activeStream = activeClinicalStreamRef.current;
        if (activeStream) {
            sendDeviceMessageRef.current({
                action: DEVICE_MESSAGE_ACTION,
                version: DEVICE_MESSAGE_VERSION,
                type: DEVICE_MESSAGE_TYPES.PERIPHERAL_CONTROL,
                resource: CLINICAL_DEVICES_RESOURCE,
                task: CLINICAL_DEVICE_MESSAGE_TASKS.STREAM_STOP,
                encounterId,
                organizationId: deviceWebSocketOrgId,
                requestId: createDeviceMessageId("clinical-stream-stop"),
                streamSessionId: activeStream.streamSessionId,
                deviceId: activeStream.deviceId,
            });
        }
        stopClinicalDeviceViewer();
    }, [
        clearCameraStatusTimers,
        clearClinicalDeviceStatusTimers,
        clearClinicalStreamCommandRetry,
        deviceWebSocketOrgId,
        encounterId,
        stopClinicalDeviceViewer,
    ]);

    useEffect(() => {
        const syncFullscreenState = () => {
            const fullscreenElement = document.fullscreenElement
                || document.webkitFullscreenElement
                || document.msFullscreenElement;
            setIsFull(fullscreenElement?.id === "room");
        };

        document.addEventListener("fullscreenchange", syncFullscreenState);
        document.addEventListener("webkitfullscreenchange", syncFullscreenState);
        document.addEventListener("MSFullscreenChange", syncFullscreenState);

        return () => {
            document.removeEventListener("fullscreenchange", syncFullscreenState);
            document.removeEventListener("webkitfullscreenchange", syncFullscreenState);
            document.removeEventListener("MSFullscreenChange", syncFullscreenState);
        };
    }, []);

    const handleToggleFullscreen = async () => {
        try {
            await toggleFullscreen();
        } catch (error) {
            console.error("Fullscreen error:", error);
            failed(error?.message || "Unable to change fullscreen mode.");
        }
    };

    useEffect(() => {
        showChatRef.current = showChat;
      }, [showChat]);

    useEffect(() => {
        selectedCameraRef.current = selectedCamera;
    }, [selectedCamera]);

    useEffect(() => {
        selectedMicrophoneRef.current = selectedMicrophone;
    }, [selectedMicrophone]);

    useEffect(() => {
        zoomSessionTokenRef.current = sessionToken;
    }, [sessionToken]);

    const clearZoomEventHandlers = () => {
        zoomEventHandlersRef.current.forEach(({ event, handler }) => zmClient.off(event, handler));
        zoomEventHandlersRef.current = [];
    };

    const registerZoomEventHandler = (event, handler) => {
        zmClient.on(event, handler);
        zoomEventHandlersRef.current.push({ event, handler });
    };

    const refreshMediaDevices = (stream) => {
        if (!stream) return { cameraId: null, microphoneId: null };

        const cameras = stream.getCameraList?.() || [];
        const microphones = stream.getMicList?.() || [];
        const activeCamera = stream.getActiveCamera?.();
        const activeMicrophone = stream.getActiveMicrophone?.();

        const cameraId = cameras.some(({ deviceId }) => deviceId === selectedCameraRef.current)
            ? selectedCameraRef.current
            : cameras.some(({ deviceId }) => deviceId === activeCamera)
                ? activeCamera
                : cameras[0]?.deviceId || null;
        const microphoneId = microphones.some(({ deviceId }) => deviceId === selectedMicrophoneRef.current)
            ? selectedMicrophoneRef.current
            : microphones.some(({ deviceId }) => deviceId === activeMicrophone)
                ? activeMicrophone
                : microphones[0]?.deviceId || null;

        setAvailableCameras(cameras);
        setCameraCount(cameras.length);
        selectedCameraRef.current = cameraId;
        setSelectedCamera(cameraId);
        setAvailableMicrophones(microphones);
        setMicCount(microphones.length);
        selectedMicrophoneRef.current = microphoneId;
        setSelectedMicrophone(microphoneId);

        return { cameraId, microphoneId };
    };

    const startVideo = async () => {
        if (!mediaStream) return;
        setIsCameraLoading(true);

        try {
            await mediaStream.startVideo({
                cameraId: selectedCamera || undefined,
                hd: true,
            });
            setIsCameraOn(true);
            refreshMediaDevices(mediaStream);
        } catch (error) {
            console.error("Camera start error:", error);
            failed("Check your camera permission and make sure it is not being used by another application.", 4000);
        } finally {
            setIsCameraLoading(false);
        }
    };

    const startAudio = async () => {
        if (!mediaStream) return false;
        setIsAudioLoading(true);

        try {
            await mediaStream.startAudio({
                mute: false,
            });
            if (selectedMicrophone) {
                await mediaStream.switchMicrophone(selectedMicrophone);
            }
            await mediaStream.unmuteAudio();
            setIsAudioStreaming(true);
            setIsMicOn(true);
            refreshMediaDevices(mediaStream);
            return true;
        } catch (error) {
            console.error("Microphone start error:", error);
            failed("Check your microphone permission and make sure it is available.", 4000);
            return false;
        } finally {
            setIsAudioLoading(false);
        }
    };

    useEffect(() => {
        setIsLoading(false);

        return () => {
            clearZoomEventHandlers();
            const shouldLeaveSession = sessionJoinedRef.current;
            sessionJoinedRef.current = false;
            const stream = mediaStreamRef.current;
            mediaStreamRef.current = null;
            if (stream || shouldLeaveSession) {
                void (async () => {
                    if (stream) {
                        await stopZoomMedia(stream);
                    }
                    if (shouldLeaveSession) {
                        await zmClient.leave().catch((error) => console.debug("Unable to leave Zoom during cleanup:", error));
                    }
                })();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zmClient]);

    useEffect(() => {
        const fetchEncounterRecord = async () => {
            if (encounterId) {
                try {
                    const response = await getEncounterRecord({encounterId: encounterId}); 
                    setEncounterRecord(response.data);
                    const currentActor = {
                        reference: `Practitioner/${practitionerId}`,
                        display: state?.practitionerName,
                        type: "Practitioner",
                      };
                    const utcString = new Date().toISOString().split(".")[0] + ".00Z";
                
                    setPreviousParticipants(response.data?.participant);
                    setPreviousPractitioner(response.data?.practitionerId);
                    
                    let iQID = response.data?.intakeQuestions?.questionnaireResponseId?.reference.split("/")?.[1];
                    setIntakeQuestionnaireId(iQID)
                    const patientId = response.data.subject?.reference?.includes("Patient/") ? response.data.subject?.reference.split("/")[1] : null;
                    setPatientId(patientId);

                    const responseIsKioskEncounter = response?.data?.class === "kiosk";
                    const ownershipEncounterStatus = "in-progress-waitingroom";

                    const activePractitioners = getActivePractitioners(response?.data);
                    const isActive = getActivePractitioners(response?.data, practitionerId).length > 0; // if activePractitioners is 0 length, then the current practitioner is not the active practitioner
                    
                    const syncedParticipants = syncMissingParticipantsFromStatusHistory(
                        response?.data?.participant || [],
                        response?.data?.statusHistory || []
                    );

                    // if the current practitioner is not the active practitioner, add them to the participant list
                    // and set all other practitioner period.end to the current time.

                    let updatedParticipantsLists = syncedParticipants?.map(participant => {
                        if(participant?.individual?.type === "Practitioner" && participant?.individual?.reference !== `Practitioner/${practitionerId}`) {
                            return {
                                ...participant,
                                period: {
                                    ...(participant.period || {}),
                                    end: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
                                    start: participant?.period?.start,
                                },
                            };
                        }
                        return participant;
                    });
                    if(!isActive) {
                        const newParticipant = {
                          individual: {
                            reference: `Practitioner/${practitionerId}`,
                            display: practitionerName,
                            type: "Practitioner",
                          },
                          period: {
                            end: null,
                            start: utcString,
                          },
                        };
                        updatedParticipantsLists.push(newParticipant);
                    }
                    getQueueRecord({ encounterId, userOrganizationId: response?.data?.orgId })
                        .then((res) => {
                            if (res?.data?.id) {
                                setQueueRecord(res?.data);
                                if(res?.data?.id) {
                                    // if queue record exists, update it
                                    const currentPractitionerHistory = res?.data?.practitionerHistory || [];
                                    const lastPractitioner = currentPractitionerHistory?.at(-1);
                                    setPreviousAssignedPractitioner(lastPractitioner);
                                    const newPractitionerHistory = [...currentPractitionerHistory];
                                    if(!lastPractitioner || (lastPractitioner && lastPractitioner?.actor?.reference !== `Practitioner/${practitionerId}`)) {
                                        newPractitionerHistory.push({
                                        actor: {
                                            reference: `Practitioner/${practitionerId}`,
                                            display: practitionerName,
                                            type: "Practitioner",
                                        },
                                        assignedBy: {
                                            actor: {
                                            reference: `Practitioner/${practitionerId}`,
                                            display: practitionerName,
                                            type: "Practitioner",
                                            },
                                        },
                                        updatedAt: Date.now(),
                                        });
                                    }
                                    editQueueItem(
                                        {
                                        id: res?.data?.id,
                                        practitionerHistory: newPractitionerHistory,
                                        participant: updatedParticipantsLists,
                                        practitionerId: practitionerId,
                                        },
                                        res?.data?.orgId
                                    ).then((res) => {
                                        if (res?.status != true) {
                                            success("Error updating encounter");
                                            return;
                                        }
                                    }).catch((err) => {
                                        failed(err?.response?.data?.message || err?.response?.data?.error || err?.message);
                                        return;
                                    });
                                }
                                editEncounter({ 
                                encounterId: encounterId,
                                practitionerId: practitionerId,
                                practitionerName: practitionerName,
                                participant: updatedParticipantsLists,
                                actor: currentActor,
                                status: ownershipEncounterStatus,
                                encounterClass: responseIsKioskEncounter ? "kiosk" : "NULL",
                                orgId: response?.data?.orgId,
                                }).then((res) => {
                                if (res?.status != true) {
                                    failed("Error updating encounter");
                                    return;
                                }
                                }).catch((err) => {
                                failed(err?.response?.data?.message || err?.response?.data?.error || err?.message);
                                return;
                                });
                            }
                        });
                    
                    if (patientId) {
                        getPatientData(patientId)
                        .then((res) => {
                            if (res?.status === true) {
                                setPatientData(res?.result);
                                setPatientName(res?.result?.name?.[0]?.text || "");
                            }
                        })
                        .catch((res) =>
                            failed(
                                res?.response?.data?.message ||
                                res?.response?.data?.error ||
                                res.message
                            )
                        )
                    }
                    
                } catch (error) {
                    console.error("Failed to fetch encounter record:", error);
                }
            }
        };
        fetchEncounterRecord();
    }, [encounterId]);

    useEffect(() => {
        const apiBody = {
          id: user?.["custom:unique_id"],
          type: "Practitioner",
          userOrgId: adminOrgs?.[0]?.id
        };
        getSingleUser(apiBody)
          .then((res) => {
            setPractionerData(res?.data)
          })
          .catch((res) => {
            console.log("error in image upload",res)
          })
    }, []);

    const handleCamera = async () => {
        if (!mediaStream) return;

        if (!isCameraOn) {
            await startVideo();
            return;
        }

        setIsCameraLoading(true);
        try {
            await mediaStream.stopVideo();
            setIsCameraOn(false);
        } catch (error) {
            console.error("Camera stop error:", error);
            failed("Unable to stop the camera.");
        } finally {
            setIsCameraLoading(false);
        }
    };

    const handleMic = async () => {
        if (!mediaStream) return;

        setIsAudioLoading(true);
        try {
            if (isMicOn) {
                await mediaStream.stopAudio();
                await mediaStream.startAudio({ speakerOnly: true });
                setIsAudioStreaming(true);
                setIsMicOn(false);
            } else {
                if (isAudioStreaming) await mediaStream.stopAudio();
                const started = await startAudio();
                if (!started) {
                    await mediaStream.startAudio({ speakerOnly: true });
                    setIsAudioStreaming(true);
                    setIsMicOn(false);
                }
            }
        } catch (error) {
            console.error("Microphone toggle error:", error);
            try {
                await mediaStream.stopAudio();
                await mediaStream.startAudio({ speakerOnly: true });
                setIsAudioStreaming(true);
                setIsMicOn(false);
            } catch (recoveryError) {
                setIsAudioStreaming(false);
                console.debug("Unable to restore speaker-only audio:", recoveryError);
            }
            failed("Unable to change the microphone state.");
        } finally {
            setIsAudioLoading(false);
        }
    };

    const switchCamera = async (event, deviceId) => {
        if (!deviceId) {
            setCamAnchor(event.currentTarget);
            return;
        }

        try {
            if (isCameraOn) await mediaStream.switchCamera(deviceId);
            selectedCameraRef.current = deviceId;
            setSelectedCamera(deviceId);
        } catch (error) {
            console.error("Camera switch error:", error);
            failed("Unable to switch to that camera.");
        }
    };

    const switchMicrophone = async (event, deviceId) => {
        if (!deviceId) {
            setMicAnchor(event.currentTarget);
            return;
        }

        try {
            if (isMicOn) await mediaStream.switchMicrophone(deviceId);
            selectedMicrophoneRef.current = deviceId;
            setSelectedMicrophone(deviceId);
        } catch (error) {
            console.error("Microphone switch error:", error);
            failed("Unable to switch to that microphone.");
        }
    };

    const getDeviceLabel = (device, index, type) => device?.label?.trim() || `${type} ${index + 1}`;

    const resetZoomSessionState = ({ nextConnectionState = "Disconnected" } = {}) => {
        clearZoomEventHandlers();
        sessionJoinedRef.current = false;
        isInMeetingRef.current = false;
        peerVideoStateRef.current.clear();
        setIsSessionJoined(false);
        setConnectionState(nextConnectionState);
        setMediaStream(null);
        mediaStreamRef.current = null;
        setChatClient(null);
        setCurrentUser({});
        setParticipants([]);
        setSessionChat([]);
        setIsCameraOn(false);
        setIsCameraLoading(false);
        setIsMicOn(false);
        setIsAudioStreaming(false);
        setIsAudioLoading(false);
        setVideoAspectRatios({});
    };

    const markZoomSessionDisconnected = (nextConnectionState = "Closed") => {
        const activeStream = mediaStreamRef.current;
        if (activeStream) {
            void stopZoomMedia(activeStream);
        }
        resetZoomSessionState({ nextConnectionState });
    };

    zoomConnectionChangeHandlerRef.current = (payload) => {
        const nextConnectionState = payload?.state;
        if (!nextConnectionState) return;

        if (nextConnectionState === "Closed" || nextConnectionState === "Fail") {
            markZoomSessionDisconnected(nextConnectionState);
            return;
        }

        setConnectionState(nextConnectionState);
    };

    zoomSessionHealthCheckRef.current = () => {
        if (!sessionJoinedRef.current) return;

        try {
            const sessionInfo = zmClient.getSessionInfo?.();
            if (sessionInfo?.isInMeeting) return;
            markZoomSessionDisconnected("Closed");
        } catch (error) {
            console.warn("Unable to verify Zoom session state:", error);
            setConnectionState("Reconnecting");
        }
    };

    useEffect(() => {
        const handleConnectionChange = (payload) => {
            zoomConnectionChangeHandlerRef.current(payload);
        };
        zmClient.on("connection-change", handleConnectionChange);
        return () => zmClient.off("connection-change", handleConnectionChange);
    }, [zmClient]);

    useEffect(() => {
        if (!isSessionJoined) return undefined;

        const checkSessionHealth = () => zoomSessionHealthCheckRef.current();
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") checkSessionHealth();
        };
        const handleOffline = () => {
            if (sessionJoinedRef.current) setConnectionState("Reconnecting");
        };

        checkSessionHealth();
        const healthTimer = setInterval(checkSessionHealth, ZOOM_SESSION_HEALTH_CHECK_MS);
        window.addEventListener("focus", checkSessionHealth);
        window.addEventListener("offline", handleOffline);
        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            clearInterval(healthTimer);
            window.removeEventListener("focus", checkSessionHealth);
            window.removeEventListener("offline", handleOffline);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [isSessionJoined]);

    const endZoomSession = async (endForEveryone = true) => {
        const activeStream = mediaStreamRef.current || mediaStream;
        isInMeetingRef.current = false;
        if (!sessionJoinedRef.current) {
            if (activeStream) {
                await stopZoomMedia(activeStream);
            }
            resetZoomSessionState();
            return;
        }

        sessionJoinedRef.current = false;
        try {
            if (activeStream) {
                await stopZoomMedia(activeStream);
            }
            await zmClient.leave(endForEveryone);
            resetZoomSessionState();
        } catch (error) {
            sessionJoinedRef.current = true;
            isInMeetingRef.current = true;
            throw error;
        }
    };

    const init = async ({ reconnect = false } = {}) => {
        if (sessionJoinedRef.current || isJoiningRef.current) return false;
        isJoiningRef.current = true;

        try {
                setIsLoading(true);
                setLoadingText(reconnect ? 'Reconnecting to the session...' : 'Joining the session...');
                isInMeetingRef.current = true;
                setConnectionState(reconnect ? "Reconnecting" : "Connecting");

                if (!zoomInitializedRef.current) {
                    await zmClient.init('en-US', 'Global', {
                        patchJsMedia: true,
                        stayAwake: true,
                        leaveOnPageUnload: true,
                        enforceMultipleVideos: true,
                    });
                    zoomInitializedRef.current = true;
                }

                let joinToken = zoomSessionTokenRef.current;
                if (reconnect) {
                    const signatureResponse = await getSignature({
                        topic: decryptData(topic),
                        role: 1,
                        password: decryptData(password),
                    });
                    joinToken = signatureResponse?.data?.sessionToken;
                    if (!joinToken) {
                        throw new Error("Unable to obtain a fresh Zoom session token.");
                    }
                    zoomSessionTokenRef.current = joinToken;
                }

                await zmClient.join(
                    decryptData(topic),
                    joinToken,
                    decryptData(user?.name?.[0]?.text?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')),
                    decryptData(password),
                );
                const joinedUser = zmClient.getCurrentUserInfo();
                if (!zmClient.getSessionInfo?.()?.isInMeeting || !joinedUser?.userId) {
                    throw new Error("Zoom did not confirm that the practitioner joined the session.");
                }
                const stream = zmClient.getMediaStream();
                const chat = zmClient.getChatClient();
                sessionJoinedRef.current = true;

                // SDK 2.x resolves join() with an empty success value, not a session object.
                setIsSessionJoined(true);
                setHasJoinedZoomSession(true);
                setConnectionState("Connected");
                setCurrentUser(joinedUser);
                peerVideoStateRef.current = new Map(
                    zmClient.getAllUser().map((participant) => [participant.userId, Boolean(participant.bVideoOn)]),
                );
                setParticipants(zmClient.getAllUser());
                setSessionChat(chat.getHistory());
                setMediaStream(stream);
                mediaStreamRef.current = stream;
                setChatClient(chat);

                clearZoomEventHandlers();
                const syncParticipants = (eventParticipants = []) => {
                    const mergedParticipants = new Map(
                        zmClient.getAllUser().map((participant) => [participant.userId, participant]),
                    );
                    eventParticipants.forEach((participant) => {
                        const existing = mergedParticipants.get(participant.userId) || {};
                        mergedParticipants.set(participant.userId, { ...existing, ...participant });
                    });

                    setParticipants(
                        Array.from(mergedParticipants.values()).map((participant) => ({
                            ...participant,
                            bVideoOn: peerVideoStateRef.current.has(participant.userId)
                                ? peerVideoStateRef.current.get(participant.userId)
                                : Boolean(participant.bVideoOn),
                        })),
                    );
                };

                registerZoomEventHandler('chat-on-message', (payload) => {
                    if (!showChatRef.current) {
                        setUnReadChat(true);
                        info("Patient has sent a message");
                    }
                    setSessionChat(
                        payload?.sender?.userId === zmClient.getCurrentUserInfo()?.userId
                            ? chat.getHistory()
                            : [...chat.getHistory(), payload],
                    );
                });

                registerZoomEventHandler('user-added', (payload) => {
                    localStorage.setItem("userJoined", "1");
                    payload.forEach((participant) => {
                        peerVideoStateRef.current.set(participant.userId, Boolean(participant.bVideoOn));
                        if (participant.userId !== zmClient.getCurrentUserInfo()?.userId) {
                            info(`New User Joined, ${participant.displayName}`);
                        }
                    });
                    syncParticipants(payload);
                });

                registerZoomEventHandler('user-removed', (payload) => {
                    const removedUserIds = new Set(payload.map((participant) => participant.userId));
                    payload.forEach((participant) => {
                        peerVideoStateRef.current.delete(participant.userId);
                        info(`${participant.displayName} left the session`);
                    });
                    setParticipants((currentParticipants) => (
                        currentParticipants.filter((participant) => !removedUserIds.has(participant.userId))
                    ));
                });
                registerZoomEventHandler('user-updated', (payload) => {
                    payload.forEach((participant) => {
                        if (typeof participant.bVideoOn === 'boolean') {
                            peerVideoStateRef.current.set(participant.userId, participant.bVideoOn);
                        }
                    });
                    syncParticipants(payload);
                });
                registerZoomEventHandler('peer-video-state-change', (payload) => {
                    peerVideoStateRef.current.set(payload.userId, payload.action === 'Start');
                    syncParticipants();
                    setMediaRevision((revision) => revision + 1);
                });
                registerZoomEventHandler('video-capturing-change', (payload) => {
                    const videoOn = payload.state === 'Started';
                    peerVideoStateRef.current.set(joinedUser.userId, videoOn);
                    setIsCameraOn(videoOn);
                    syncParticipants([{ ...joinedUser, bVideoOn: videoOn }]);
                    setMediaRevision((revision) => revision + 1);
                });
                registerZoomEventHandler('video-aspect-ratio-change', ({ userId, aspectRatio }) => {
                    if (!Number.isFinite(userId) || !Number.isFinite(aspectRatio) || aspectRatio <= 0) return;
                    setVideoAspectRatios((currentRatios) => (
                        currentRatios[userId] === aspectRatio
                            ? currentRatios
                            : { ...currentRatios, [userId]: aspectRatio }
                    ));
                });
                registerZoomEventHandler('connection-change', (payload) => {
                    if (payload.state === 'Connected') {
                        syncParticipants();
                        setMediaRevision((revision) => revision + 1);
                    }
                });
                registerZoomEventHandler('device-change', () => refreshMediaDevices(stream));
                registerZoomEventHandler('device-permission-change', () => refreshMediaDevices(stream));

                refreshMediaDevices(stream);

                try {
                    await stream.startAudio({
                        speakerOnly: true,
                    });
                    setIsAudioStreaming(true);
                    setIsMicOn(false);
                    refreshMediaDevices(stream);
                } catch (audioError) {
                    console.error("Unable to connect practitioner audio:", audioError);
                    failed("The session joined, but microphone access is unavailable.", 4000);
                }

                await updateQueueHostJoined();
                return true;
        } catch (e) {
            const activeStream = mediaStreamRef.current;
            if (activeStream) await stopZoomMedia(activeStream);
            try {
                if (zmClient.getSessionInfo?.()?.isInMeeting) await zmClient.leave(false);
            } catch (leaveError) {
                console.debug("Unable to leave Zoom after a failed join:", leaveError);
            }
            resetZoomSessionState({ nextConnectionState: "Fail" });
            failed(e?.reason || e?.type || e?.message || "Unable to join the Zoom session.");
            if (!reconnect) navigate(-1);
            return false;
        } finally {
            setIsLoading(false);
            isJoiningRef.current = false;
        }
    };

    const handleJoinSession = async () => {
        await init();
    }

    const handleReconnectSession = async () => {
        if (hasEndedZoomSession || isJoiningRef.current) return;

        setConnectionState("Reconnecting");
        const activeStream = mediaStreamRef.current;
        sessionJoinedRef.current = false;
        clearZoomEventHandlers();
        if (activeStream) await stopZoomMedia(activeStream);

        try {
            if (zmClient.getSessionInfo?.()?.isInMeeting) {
                await zmClient.leave(false);
            }
        } catch (error) {
            console.debug("Unable to leave the stale Zoom session before reconnecting:", error);
        }

        resetZoomSessionState({ nextConnectionState: "Reconnecting" });
        await init({ reconnect: true });
    };

    // here we will set the isHostJoined to true once the host clicks Start Call
    const updateQueueHostJoined = async () => {
        try {
            await editQueueItem({ id: state?.encounterId, isHostJoined: true }, adminOrgs?.[0]?.id)

        } catch (error) {
            console.log("Failed to update queue item with host joined", error);
        }
    }

    const handleEndSession = () => {
        if (encounterFinished || hasEndedZoomSession) return;
        if (activeClinicalStreamRef.current) {
            failed("Stop the active device stream before ending the call.");
            return;
        }
        setEndCallConfirmationShow(true);
    };

    const handleConfirmEndSession = () => {
        setEndCallConfirmationShow(false);
        if(encounterFinished || hasEndedZoomSession) return;
        if (activeClinicalStreamRef.current) {
            failed("Stop the active device stream before ending the call.");
            return;
        }
        setHasEndedZoomSession(true);
        isInMeetingRef.current = false;
        if (isFull) void handleToggleFullscreen();
        setIsLoading(true)
        setLoadingText("Ending Session")
        localStorage.removeItem("userJoined")
        endZoomSession(true).then(() => {
            state?.isWaitingRoom && endWaitingRoomMeeting({ id: state?.id, patientId: state?.patientId })
                .then((res) => success(res.message))
                .catch((err) => console.log(err))
            setEncounterFinished(true);
        }).catch((err) => {
            setHasEndedZoomSession(false);
            console.log(err);
        }).finally(() => {
            setIsLoading(true)
            setLoadingText("Ending Session")
        }).finally(() =>    setIsLoading(false)
        )
    }

    const handleProceedSessionConfirmation = () => {
        if (!isQuestionnaireCompleted) {
            failed("Save questionnaire before proceeding");
            return;
        } 
        if (!encounterFinished) {
            setconfirmmodalShow(true);
        } else {
            formikRef.current && formikRef.current();
            handleProceedSession();
        }
    };
    
    const handleConfirm = async () => { 
        formikRef.current && formikRef.current();
        handleProceedSession();
    }; 
    
    const handleCancel = () => {
        setconfirmmodalShow(false);
    };

    const handleProceedSession = () => { 
        if(!isQuestionnaireCompleted){
            failed("Save questionnaire before proceeding");
            return;
        }
        if(!encounterFinished){
            setIsLoading(true)
            setLoadingText("Ending Session")
            if(sessionJoinedRef.current) {
                localStorage.removeItem("userJoined")
                endZoomSession(true).then(() => {
                    state?.isWaitingRoom && endWaitingRoomMeeting({ id: state?.id, patientId: patientId })
                        .then((res) => success(res.message))
                        .catch((err) => console.log(err))
                    setEncounterFinished(true);
                    const url = `/app/encounter-details?encounterId=${state?.encounterId}`;
                    navigate(url, { replace: true });
                }).catch((err) => console.log(err)).finally(() => {
                    setIsLoading(true)
                    setLoadingText("Ending Session")
                }).finally(() =>    setIsLoading(false))
            }
            else {
                resetZoomSessionState();
                state?.isWaitingRoom && endWaitingRoomMeeting({ id: state?.id, patientId: patientId })
                    .then((res) => success(res.message))
                    .catch((err) => console.log(err))
                setEncounterFinished(true);
                const url = `/app/encounter-details?encounterId=${state?.encounterId}`;
                navigate(url, { replace: true });
            }            
        }
        else{
            setLoadingText("Proceed Ending Session")
            setEncounterFinished(true);
            const url = `/app/encounter-details?encounterId=${state?.encounterId}`;
            navigate(url, { replace: true });
        }
        
    }
    const handleSendMsg = async (event) => {
        event.preventDefault();
        const message = chatInput.current?.value?.trim();
        if (!message) {
            chatInput.current?.focus();
            return;
        }
        if (!chatClient) {
            failed("Chat is not available until the video session is connected.");
            return;
        }

        try {
            await chatClient.sendToAll(message);
            if (chatInput.current) chatInput.current.value = "";
        } catch (error) {
            console.error("Zoom chat send error:", error);
            failed("Unable to send the message.");
        }
    }
    useEffect(() => {
        getProtocolResponses();
        getOrganization(adminOrgs?.[0]?.id)
            .then((res) => {
                setOrganizations(res.data);
            })
            .catch((res) => {
                failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
            });
      }, []);

    const remoteParticipants = participants.filter(
        (participant) => participant.userId !== currentUser?.userId,
    );
    const isZoomConnected = isSessionJoined && connectionState === "Connected";
    const connectionStatusClass = hasEndedZoomSession
        ? "closed"
        : isZoomConnected
            ? "connected"
            : connectionState === "Connecting" || connectionState === "Reconnecting"
                ? "reconnecting"
                : connectionState === "Fail"
                    ? "fail"
                    : connectionState === "Closed"
                        ? "closed"
                        : "disconnected";
    const connectionLabel = hasEndedZoomSession
        ? "Call ended"
        : isZoomConnected
            ? "Connected"
            : connectionState === "Connecting"
                ? "Connecting..."
                : connectionState === "Reconnecting"
                    ? "Reconnecting..."
                    : hasJoinedZoomSession
                        ? "Not connected"
                        : "Ready to connect";

    const handleView = (data) => {
        const baseUrl = window.location.origin;
        const url = `${baseUrl}/app/patients-details?patientId=${patientId}`//&patientName=${patientName}`;
        window.open(url, "_blank");
    };

    const handleServiceRequest = () => {
        window.open(`/app/service-request?encounterId=${state?.encounterId}&patientId=${patientId}&fromPatient=false`, '_blank')
    }
    const handleMedicationRequest = () => {
        window.open(`/app/encounter-medication-request?encounterId=${state?.encounterId}&practitionerId=${practitionerId}&patientId=${patientId}&fromPatient=false`, '_blank')
    }

    const completeParkFollowUpZoomExit = () => {
        setIsLoading(true);
        setLoadingText("Ending Session");
        localStorage.removeItem("userJoined");

        const clearVideoUi = () => {
            const roomEl = document.getElementById("room");
            if (roomEl) {
                roomEl.replaceChildren();
                roomEl.style.width = "0%";
            }
            const participantsView = document.getElementById("participants-view");
            if (participantsView) {
                participantsView.replaceChildren();
            }
        };

        const endWaitingRoomThenNavigate = () => {
            const wrPromise = state?.isWaitingRoom
                ? endWaitingRoomMeeting({ id: state?.id, patientId: state?.patientId })
                    .then((res) => success(res.message))
                    .catch((err) => console.log(err))
                : Promise.resolve();
            return wrPromise.then(() => navigate("/app/dashboard"));
        };

        const afterLeaveOrSkip = () => {
            clearVideoUi();
            return endWaitingRoomThenNavigate();
        };

        endZoomSession(true)
            .then(afterLeaveOrSkip)
            .catch((err) => {
                console.log(err);
                return afterLeaveOrSkip();
            })
            .finally(() => setIsLoading(false));
    };

    if (!(topic && sessionToken && password)) {
        return <h1>Do not have the meeting details!</h1>
    }

    const handleParkCallClick = () => {
        if(!isQuestionnaireCompleted){
            failed("Save questionnaire before proceeding");
            return;
        }
        if(encounterFinished){
            navigate("/app/dashboard");
        } else {
            completeParkFollowUpZoomExit();
        }
    }

    const handleIsQuestionnaireComplete = (isComplete) => {
        if (isComplete) { 
            setIsQuestionnaireCompleted(isComplete); 
        }  
      };

    const handleFollowUpCallClick = () => {
        if(!isQuestionnaireCompleted){
            failed("Save questionnaire before proceeding");
            return;
        }
        if(encounterFinished){
            navigate("/app/dashboard");
        } else {
            completeParkFollowUpZoomExit();
        }
    }

    const handleProtocolAssessmentClick = () => {
        setLoadingText("Loading...");
        setIsLoading(true);
        getProtocolResponsesByEncounterId(encounterId, encounterRecord?.orgId)
          .then((res) => {
            const parsedResponse = JSON.parse(res?.body);
            if (parsedResponse?.data && parsedResponse?.data?.length > 0) {
              const baseUrl = window.location.origin;
              const url = `${baseUrl}/app/protocol-assessment?encounterId=${encounterId}`;
              window.open(url, "_blank");
            } else {
              let payload = {
                resourceType: "ProtocolResponse",
                status: "in-progress",
                encounterId: encounterId,
                orgId: encounterRecord.orgId,
                authored: moment().toISOString(),
                author: {
                  display: practitionerName,
                  reference: `Practitioner/${practitionerId}`,
                  type: "Practitioner",
                },
                authorId: practitionerId,
                encounter: {
                  reference: `Encounter/${encounterId}`,
                },
                managingOrganization: {
                  reference: `Organization/${encounterRecord.orgId}`,
                  type: "Organization",
                },
                subject: encounterRecord?.subject,
              };
              console.log(
                "Creating a protocol response record here with payload: ",
                payload
              );
              createProtocolResponse(encounterRecord.orgId, payload).then((res) => {
                setTriageBtnState(false);
                setShowTriageComponent(true);
              });
            }
          })
          .catch((res) =>
            failed(
              res?.response?.data?.message ||
                res?.response?.data?.error ||
                res.message
            )
          )
          .finally(() => setIsLoading(false));
      };

    const hideTriageBtn = () => {
      setTriageBtnState(false);
    };

    const getProtocolResponses = () => {
        if (isContactCenterActive && permissions.includes("Read Protocol Response") && encounterRecord?.orgId) {
            getProtocolResponsesByEncounterId(encounterId, encounterRecord?.orgId)
                .then((res) => {
                    const parsedResponse = JSON.parse(res?.body);
                    if (parsedResponse?.data?.length > 0) {
                        setShowTriageComponent(true);
                    }
                })
            }
    }
    
    const getHcnValue = (data) => {
        let hcnValue;
        if(data ){
            for (let i = 0; i < data?.identifier?.length; i++) {    
                if (data?.identifier[i].type === "HCN") {      
                    hcnValue = data?.identifier[i].value;
                    break;
                }
            }
        }
        return hcnValue;
    }

    if (!(topic && sessionToken && password)) {
        return (
            <section className="common-listing">
                <div className="zoom-session-error" role="alert">
                    <h1>Video visit details are missing</h1>
                    <p>Return to the previous page and start the visit again.</p>
                    <Button className="custom-btn" variant="primary" onClick={() => navigate(-1)}>
                        Go back
                    </Button>
                </div>
            </section>
        );
    };

    const clinicalStreamState = activeClinicalStream?.stopping
        ? CLINICAL_STREAM_STATES.STOPPING
        : kioskClinicalStreamStatus?.state === CLINICAL_STREAM_STATES.FAILED
            ? CLINICAL_STREAM_STATES.FAILED
            : [
                CLINICAL_STREAM_STATES.CONNECTING,
                CLINICAL_STREAM_STATES.STREAMING,
                CLINICAL_STREAM_STATES.RECONNECTING,
                CLINICAL_STREAM_STATES.FAILED,
            ].includes(clinicalViewerStatus.state)
                ? clinicalViewerStatus.state
                : kioskClinicalStreamStatus?.state || CLINICAL_STREAM_STATES.STARTING;
    const clinicalStreamMessage = kioskClinicalStreamStatus?.message
        || clinicalViewerStatus?.message;

    return (
        encounterDetailsShow ?  
        <EncounterDetail  setEncouterDetailsShow = {setEncouterDetailsShow} EncounterId = {state?.encounterId} PatientId= {patientId} PractionerData= {practionerData} PractitionerId = {practitionerId} ShowCompleteButton = {true} />
        :
        
        <div>
        <section className="common-listing">
            {isLoading && <FullPageSpinner loadingText={loadingText} />}
                <div className="patient-info">
                <div className='patient-info-container'>
                    <div className='patient-info-grid'>
                        <div className='info-column'>
                            <div className='info-item'><strong>Patient:</strong> <span>{capitalizeWords(patientName) || "-"}</span></div>
                            <div className='info-item'><strong>Patient Identifier:</strong> <span>{getHcnValue(patientData) || "-"}</span></div>
                        </div>
                        <div className='info-column'>
                            <div className='info-item'><strong>Age:</strong> <span>{ViewDate(patientData?.birthDate) + " - " + safeAgeString(patientData?.birthDate)}{patientData?.gender && ` - ${capitalizeWords(patientData?.gender)}`}</span></div>
                            <div className='info-item'><strong>Contact:</strong> <span>{intakeQuestions?.callerNumber || "-"} {intakeQuestions?.callerNumberExt && `ext. ${intakeQuestions?.callerNumberExt}`}</span></div>
                        </div>
                        <div className='info-column'>
                            <div className='info-item'><strong>Organization:</strong> <span>{(encounterRecord?.serviceProvider?.display) || (encounterRecord?.managingOrganization?.display) || "-"}</span></div>
                            <div className='info-item'><strong>Service Line:</strong> <span>{encounterRecord?.serviceLine?.display || "-"}</span></div>
                        </div>
                    </div>
                    {encounterRecord?.intakeQuestions?.callerRelationship !== "Self" && (
                        <div className='patient-info-row-2'>
                            <div className='info-item'><strong>Caller Name:</strong> <span>{capitalizeWords(intakeQuestions?.callerName ) || "-"} </span></div>
                            <div className='info-item'><strong>Relationship:</strong> <span>{capitalizeWords(encounterRecord?.intakeQuestions?.callerRelationship) || "-"}</span></div>
                        </div>
                    )}
                </div>

                {/* Zoom Buttons */}
                <div>
                {state?.isWaitingRoom ? null : <div className="right-wrap">
                    <Button className="custom-btn" style={{ fontSize: "12px" }} title="Open Dashboard in a new tab" variant="primary" onClick={handleView}>Dashboard</Button>
                    {hasResourcesReadPermissions && <Button style={{ fontSize: "12px" }} className="custom-btn" title="Resources" variant="primary" onClick={() => setResourceModalShow(true)}>Resources</Button>}
                    <Button className="custom-btn" style={{ fontSize: "12px" }} title="Invite" variant="primary" onClick={() => setModalShow(true)}> Invite</Button>
                    <InviteInSeesion
                        encounter={encounterRecord}
                        show={modalShow}
                        topic={decryptData(topic)}
                        password={decryptData(password)}
                        onHide={() => setModalShow(false)}
                    />
                    <Resources
                        show={resourceModalShow}
                        onHide={() => setResourceModalShow(false)}
                    /> 
                    {isVirtualCare && permissions.includes("Create Prescriptions") && (<Button className="custom-btn ms-2" title="Create Prescription" variant="primary" style={{ padding: "0" }} onClick={()=>  orgnization?.sft?.enabled && (orgnization?.sft?.individualDelivery || orgnization?.sft?.locationDelivery) ?  handleMedicationRequest() : (orgnization?.sft?.enabled && (!orgnization?.sft?.individualDelivery && !orgnization?.sft?.locationDelivery)) ? failed("Please enable SFT delivery options.") : failed("Please enable SFT to send document.")}><img src={medicalIcon} alt="Prev Arrow" /></Button>)}
                    {isVirtualCare && (permissions.includes("Create Service Referrals") || permissions.includes("Create Diagnostic Imaging Requests") || permissions.includes("Create Lab Requisitions") ) && (<Button className="custom-btn ms-2" title="Add Referral service request" variant="primary" style={{ padding: "0" }} onClick={() => orgnization?.sft?.enabled && (orgnization?.sft?.individualDelivery || orgnization?.sft?.locationDelivery)? handleServiceRequest() : (orgnization?.sft?.enabled && (!orgnization?.sft?.individualDelivery && !orgnization?.sft?.locationDelivery)) ? failed("Please enable SFT delivery options.") : failed("Please enable SFT to send document.")}><img src={referralIcon} alt="Prev Arrow" /></Button>)}
                    <Button className="custom-btn ms-2" title={`Open ${showChat ? "Questionnaire" : "Chat"}`} style={{ fontSize: "12px" , background: unReadChat && !showChat ? "#c24c4c" : undefined}} variant="primary" onClick={() => {const newshowChat = !showChat; setShowChat(newshowChat); if(newshowChat) setUnReadChat(false);}}>{showChat ? "Questionnaire" : "Chat" }</Button>
                    {isVirtualCare && (<Button className="custom-btn ms-2" title="Schedule Apt." variant="primary" onClick={() => setBookingModalShow(true)}>Schedule Apt.</Button>)}
                    {canAddToWaitingRoom({ organization: orgnization, state, encounterRecord }) && (<Button className="custom-btn ms-2" title="Add to Waiting Room" variant="primary" onClick={() => setAddToWRModalShow(true)}>Add to Waiting Room</Button>)}
                    <ConfirmationModal
                        show={confirmmodalShow}
                        onConfirm={handleConfirm}
                        onCancel={handleCancel} 
                        message="Are you sure you want to end this encounter?"
                    />
                    {bookingModalShow ? (
                        <BookingModal
                            modalShow={bookingModalShow}
                            type="inprogress"
                            onHide={() => setBookingModalShow(false)}
                            patientId={typeof patientId === "string" ? patientId : patientId?.id}
                            patientName={patientName}
                            encounterId={state?.encounterId}
                            orgId={encounterRecord?.orgId || orgnization?.id}
                            orgName={orgnization?.name}
                            intakePrefill={{
                                reason: encounterRecord?.intakeQuestions?.intakeReason,
                                phone: encounterRecord?.intakeQuestions?.callerNumber,
                                channel: encounterRecord?.intakeQuestions?.preferredChannel || "video/chat",
                            }}
                        />
                    ) : null}
                    {addToWRModalShow ? (
                        <AddToWaitingRoomModal
                            data={{
                                patient: encounterRecord?.subject,
                                orgId: encounterRecord?.orgId || orgnization?.id,
                                orgName: encounterRecord?.serviceProvider?.display || encounterRecord?.managingOrganization?.display || orgnization?.name,
                                intakeQuestions: encounterRecord?.intakeQuestions,
                                requestedPeriod: encounterRecord?.requestedPeriod,
                                practitionerId: encounterRecord?.practitionerId,
                                practitionerName: practitionerName,
                                proceedWith: "WAITING_ROOM",
                                status: "in-progress-intake",
                                encounterId: encounterRecord?.id || state?.encounterId,
                                patientLocation: encounterRecord?.patientLocation,
                                period: encounterRecord?.period,
                            }}
                            onShow={addToWRModalShow}
                            onHide={() => setAddToWRModalShow(false)}
                            handleShow={() => navigate("/app/waiting-room", { replace: true })}
                        />
                    ) : null}
                </div>}
                </div>
            </div>

            <EndCallConfirmationModal
                show={endCallConfirmationShow}
                onConfirm={handleConfirmEndSession}
                onCancel={() => setEndCallConfirmationShow(false)}
                container={() => document.getElementById("room")}
            />

            <div className="call-chat-outer">
                <div className="zoom-call-shell" id="room">
                    <div className="call-screen-wrap zoom-call-stage">
                        <div className="zoom-call-statusbar">
                            <span className={`zoom-connection-state zoom-connection-state--${connectionStatusClass}`}>
                                <span className="zoom-connection-state__dot" />
                                {connectionLabel}
                            </span>
                            <span>{isZoomConnected ? `${participants.length} participant${participants.length === 1 ? "" : "s"}` : "Video visit"}</span>
                        </div>

                        {isKioskEncounter && isSessionJoined && (
                            <KioskPtzControls
                                connectionState={deviceSocketState}
                                cameraStatus={kioskCameraStatus}
                                pending={Boolean(pendingPtzCommand)}
                                feedback={ptzFeedback}
                                onMove={handlePtzMovement}
                            />
                        )}

                        <div
                            id="participants-view"
                            className={`zoom-remote-grid zoom-remote-grid--${Math.min(remoteParticipants.length, 4)}`}
                        >
                            {remoteParticipants.length > 0 ? remoteParticipants.map((participant) => (
                                <div className="participant-view zoom-participant-tile" id={`${participant.userId}`} key={participant.userId}>
                                    {participant.bVideoOn ? (
                                        <ZoomVideoPlayer
                                            stream={mediaStream}
                                            userId={participant.userId}
                                            videoOn
                                            retryToken={mediaRevision}
                                            label={`${participant.displayName || "Participant"} video`}
                                            className="participant-canvas"
                                        />
                                    ) : (
                                        <div className="participant-avatar zoom-participant-placeholder">
                                            <div>{getParticipantInitials(participant.displayName)}</div>
                                            <span>Camera is off</span>
                                        </div>
                                    )}
                                    <div className="zoom-participant-name">
                                        {participant.displayName || "Participant"}
                                        {participant.muted && <MicOffOutlined fontSize="small" />}
                                    </div>
                                </div>
                            )) : (
                                <div className="zoom-empty-state">
                                    <div className="zoom-empty-state__icon"><VideocamOutlined /></div>
                                    <strong>{hasEndedZoomSession ? "Call ended" : isZoomConnected ? "Waiting for the patient" : hasJoinedZoomSession ? "Zoom connection lost" : "Ready for the video visit"}</strong>
                                    <span>{hasEndedZoomSession ? "Continue documenting below when you are ready." : isZoomConnected ? "Their video will appear here as soon as they join." : hasJoinedZoomSession ? "Use Reconnect to rejoin without refreshing this page." : "Start the call when you are ready."}</span>
                                </div>
                            )}
                        </div>

                        {isZoomConnected && (
                            <div className="zoom-self-view">
                                {isCameraOn ? (
                                    <ZoomVideoPlayer
                                        stream={mediaStream}
                                        userId={currentUser?.userId}
                                        videoOn
                                        retryToken={mediaRevision}
                                        label="Your video"
                                        isSelf
                                        fit="cover"
                                        aspectRatio={videoAspectRatios[currentUser?.userId]}
                                    />
                                ) : (
                                    <div className="zoom-self-view__placeholder">
                                        {getParticipantInitials(currentUser?.displayName || practitionerName)}
                                    </div>
                                )}
                                <span>You</span>
                            </div>
                        )}

                        <ClickAwayListener onClickAway={() => {setCamAnchor(null);setMicAnchor(null)}}>
                            <div className="tool-wrap zoom-call-controls" aria-label="Call controls">
                                <div className="zoom-control-group">
                                    <button
                                        type="button"
                                        className={`zoom-control-button ${!isMicOn ? "zoom-control-button--off" : ""}`}
                                        disabled={!isZoomConnected || isAudioLoading}
                                        onClick={handleMic}
                                        aria-pressed={isMicOn}
                                    >
                                        {isMicOn ? <MicOutlined /> : <MicOffOutlined />}
                                        <span>{isAudioLoading ? "Working..." : isMicOn ? "Mute" : "Unmute"}</span>
                                    </button>
                                    {micCount > 0 && (
                                        <button
                                            type="button"
                                            className="zoom-device-button"
                                            disabled={!isZoomConnected || isAudioLoading}
                                            onClick={switchMicrophone}
                                            aria-label="Select microphone"
                                        >
                                            <KeyboardArrowDown />
                                        </button>
                                    )}
                                </div>

                                <div className="zoom-control-group">
                                    <button
                                        type="button"
                                        className={`zoom-control-button ${!isCameraOn ? "zoom-control-button--off" : ""}`}
                                        disabled={!isZoomConnected || isCameraLoading}
                                        onClick={handleCamera}
                                        aria-pressed={isCameraOn}
                                    >
                                        {isCameraOn ? <VideocamOutlined /> : <VideocamOffOutlined />}
                                        <span>{isCameraLoading ? "Working..." : isCameraOn ? "Stop video" : "Start video"}</span>
                                    </button>
                                    {cameraCount > 1 && (
                                        <button
                                            type="button"
                                            className="zoom-device-button"
                                            disabled={!isZoomConnected || isCameraLoading}
                                            onClick={switchCamera}
                                            aria-label="Select camera"
                                        >
                                            <KeyboardArrowDown />
                                        </button>
                                    )}
                                </div>

                                <button
                                    type="button"
                                    className="zoom-control-button"
                                    onClick={handleToggleFullscreen}
                                    disabled={!isZoomConnected && !isFull}
                                >
                                    {isFull ? <FullscreenExit /> : <Fullscreen />}
                                    <span>{isFull ? "Exit full screen" : "Full screen"}</span>
                                </button>

                                {hasEndedZoomSession ? (
                                    <button type="button" className="zoom-control-button zoom-control-button--end" disabled>
                                        <CallEndOutlined />
                                        <span>Call ended</span>
                                    </button>
                                ) : !isZoomConnected ? (
                                    <button
                                        type="button"
                                        className="zoom-control-button zoom-control-button--start"
                                        onClick={hasJoinedZoomSession ? handleReconnectSession : handleJoinSession}
                                        disabled={isLoading}
                                    >
                                        {hasJoinedZoomSession ? <Refresh /> : <CallOutlined />}
                                        <span>{hasJoinedZoomSession ? "Reconnect" : "Start call"}</span>
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        className="zoom-control-button zoom-control-button--end"
                                        onClick={handleEndSession}
                                        disabled={Boolean(activeClinicalStream)}
                                        title={activeClinicalStream ? "Stop the active device stream before ending the call." : "End call"}
                                    >
                                        <CallEndOutlined />
                                        <span>{activeClinicalStream ? "Stop device first" : "End call"}</span>
                                    </button>
                                )}
                            </div>
                        </ClickAwayListener>
                    </div>
                    {isKioskEncounter && (
                        <>
                        {activeClinicalStream && (
                            <ClinicalDeviceStreamView
                                deviceId={activeClinicalStream.deviceId}
                                stream={clinicalRemoteStream}
                                state={clinicalStreamState}
                                message={clinicalStreamMessage}
                                onStop={requestClinicalStreamStop}
                            />
                        )}
                        <KioskClinicalDeviceStatus
                            className="zoom-kiosk-clinical-status"
                            connectionState={deviceSocketState}
                            snapshot={kioskClinicalDeviceStatus}
                            statusState={kioskClinicalDeviceStatusState}
                            onDeviceAction={handleClinicalDeviceAction}
                            activeDeviceId={activeClinicalStream?.deviceId}
                            streamState={clinicalStreamState}
                            disabled={endCallConfirmationShow || hasEndedZoomSession || Boolean(activeClinicalStream?.stopping)}
                        />
                        </>
                    )}
                </div>
                <ZoomChatBox handleProceedSessionConfirmation={handleProceedSessionConfirmation} show={showChat} currentUser={currentUser} sessionChat={sessionChat} chatInput={chatInput} handleSendMsg={handleSendMsg} handleParkCallClick={handleParkCallClick} handleFollowUpClick={handleFollowUpCallClick}/>
                <QuestionnaireBox handleProceedSessionConfirmation={handleProceedSessionConfirmation} show={!showChat} onHide={() => setShowChat(true)} encounterId={state?.encounterId} patientId={patientId} intakeQuestionnaireId={intakeQuestionnaireId} patientName={patientName} handleParkCallClick={handleParkCallClick} handleFollowUpClick={handleFollowUpCallClick} handleIsQuestionnaireComplete={(isComplete) => handleIsQuestionnaireComplete(isComplete)} encounterRecord={encounterRecord} handleProtocolAssessmentClick={handleProtocolAssessmentClick} triageBtnState={triageBtnState} isContactCenterActive={isContactCenterActive} permissions={permissions} ref={formikRef}/>
            </div>
            {
                // MENU FOR CAMERA SELECTION IF NEEDED
                availableCameras?.length > 1 && <Menu anchorEl={camAnchor} open={camOpen}
                    container={() => document.getElementById("room")}
                    onClose={() => setCamAnchor(null)}
                    anchorOrigin={{
                        vertical: "middle",
                        horizontal: "left",
                    }}
                    transformOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}>
                        <MenuList style={{padding:0,margin:0}} dense>{                                        
                            availableCameras?.map((cam, index) => {
                                return (<MenuItem 
                                    key={cam.deviceId}
                                    value={cam.deviceId} 
                                    selected={cam.deviceId === selectedCamera}
                                    onClick={(event) => {switchCamera(event, cam.deviceId); setCamAnchor(null)}} 
                                    className="camPicker" >
                                    {getDeviceLabel(cam, index, "Camera")}
                                    {cam.deviceId === selectedCamera && <ListItemIcon><Check /></ListItemIcon> }
                                </MenuItem>)
                            })
                        }
                        </MenuList>
                </Menu>}
                {
                // MENU FOR MICROPHONE SELECTION IF NEEDED
                availableMicrophones?.length > 0 && <Menu anchorEl={micAnchor} open={micOpen}
                    container={() => document.getElementById("room")}
                    onClose={() => setMicAnchor(null)}
                    anchorOrigin={{
                        vertical: "middle",
                        horizontal: "left",
                    }}
                    transformOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}>
                        <MenuList style={{padding:0,margin:0}} dense>{                                        
                            availableMicrophones?.map((mic, index) => {
                                return (<MenuItem 
                                    key={mic.deviceId}
                                    value={mic.deviceId} 
                                    selected={mic.deviceId === selectedMicrophone}
                                    onClick={(event) => { switchMicrophone(event, mic.deviceId); setMicAnchor(null)}} 
                                    className="camPicker">
                                        {getDeviceLabel(mic, index, "Microphone")}
                                        {mic.deviceId === selectedMicrophone && <ListItemIcon><Check /></ListItemIcon> }
                                    </MenuItem>)
                            })
                        }
                        </MenuList>
                </Menu>}
        </section>
        {/* Protocol Assessment Component */}
        {(isContactCenterActive && permissions.includes("Write Protocol Response") && showTriageComponent) && <section className='common-listing-v2'>
          <div className="questionnair-wrapper-v2">
            <div className="heading-wrap h-change" style={{ display: 'flex', alignItems: 'center' }}>
              <h1 className="big-head">Protocol Assessment</h1>
            </div>
            <hr />
            <TriageParentComponent 
              encounterIdFromVisit={encounterId} 
              fetchResponses={triageBtnState} 
              hideTriageBtn={hideTriageBtn} 
            /> 
          </div>
        </section>}
        </div>
    );
}

export default ZoomCreate;
